<div class="dialog-content-wrapper">

  <form [formGroup]="editForm" class="k-form-inline">

    <div class="k-form-field">
      <label class="form-label col-4 k-label" for="organisation_id">Organisation</label>
      <div class="col-7">
        <kendo-dropdownlist id="organisation_id" formControlName="organisation_id" [data]="organisations"
          [valuePrimitive]="true" textField="organisation_name" valueField="id"
          [defaultItem]="{ id: null, organisation_name: 'Select...' }" appAutoFocus>
        </kendo-dropdownlist>
        <div *ngIf="organisation_id?.invalid" class="alert alert-danger">
          <div *ngIf="organisation_id?.errors?.['required']">Organisation required.</div>
        </div>
      </div>
    </div>

    <div class="k-form-field">
      <label class="form-label col-4 k-label" for="discipline_id">Discipline</label>
      <div class="col-7">
        <kendo-dropdownlist id="discipline_id" formControlName="discipline_id" [data]="disciplines"
          [valuePrimitive]="true" textField="discipline_name" valueField="discipline_id"
          [defaultItem]="{ discipline_id: null, discipline_name: 'Select...' }">
        </kendo-dropdownlist>
        <div *ngIf="discipline_id?.invalid" class="alert alert-danger">
          <div *ngIf="discipline_id?.errors?.['required']">Discipline required.</div>
        </div>
      </div>
    </div>

    <div class="k-form-field">
      <label class="form-label col-4 k-label" for="evaluation_id">Evaluation</label>
      <div class="col-7">
        <kendo-dropdownlist id="evaluation_id" formControlName="evaluation_id" [data]="evaluations"
          [valuePrimitive]="true" textField="evaluation_name" valueField="id"
          [defaultItem]="{ id: null, evaluation_name: 'Select...' }">
        </kendo-dropdownlist>
        <div *ngIf="evaluation_id?.invalid" class="alert alert-danger">
          <div *ngIf="evaluation_id?.errors?.['required']">Evaluation required.</div>
        </div>
      </div>
    </div>

    <div class="k-form-field">
      <label class="form-label col-4 k-label" for="unit_of_study">Unit of Study</label>
      <div class="col-7">
        <input type="text" id="unit_of_study" formControlName="unit_of_study" class="form-control" appAutoFocus>
        <div *ngIf="unit_of_study?.invalid" class="alert alert-danger">
          <div *ngIf="unit_of_study?.errors?.['required']">Unit of Study is required.</div>
        </div>
      </div>
    </div>

    <div class="k-form-field">
      <label class="form-label col-4 k-label" for="client_contact_target_hours">Client Contact Target Hours</label>
      <div class="col-3">
        <input type="number" id="client_contact_target_hours" formControlName="client_contact_target_hours"
          class="form-control" min="0" step="0.01">
        <div *ngIf="client_contact_target_hours?.invalid" class="alert alert-danger">
          <div *ngIf="client_contact_target_hours?.errors?.['min'] || client_contact_target_hours?.errors?.['pattern']">
            Only positive numbers with up to 2 decimals allowed.
          </div>
        </div>
      </div>
    </div>

    <div class="k-form-field">
      <label class="form-label col-4 k-label" for="individual_supervision_target_hours">Individual Supervision Target
        Hours</label>
      <div class="col-3">
        <input type="number" id="individual_supervision_target_hours"
          formControlName="individual_supervision_target_hours" class="form-control" min="0" step="0.01">
        <div *ngIf="individual_supervision_target_hours?.invalid" class="alert alert-danger">
          <div
            *ngIf="individual_supervision_target_hours?.errors?.['min'] || individual_supervision_target_hours?.errors?.['pattern']">
            Only positive numbers with up to 2 decimals allowed.
          </div>
        </div>
      </div>
    </div>

    <div class="k-form-field">
      <label class="form-label col-4 k-label" for="group_supervision_target_hours">Group Supervision Target
        Hours</label>
      <div class="col-3">
        <input type="number" id="group_supervision_target_hours" formControlName="group_supervision_target_hours"
          class="form-control" min="0" step="0.01">
        <div *ngIf="group_supervision_target_hours?.invalid" class="alert alert-danger">
          <div
            *ngIf="group_supervision_target_hours?.errors?.['min'] || group_supervision_target_hours?.errors?.['pattern']">
            Only positive numbers with up to 2 decimals allowed.
          </div>
        </div>
      </div>
    </div>

    <div class="k-form-field">
      <label class="form-label col-4 k-label" for="other_activities_target_hours">Other Activities Target Hours</label>
      <div class="col-3">
        <input type="number" id="other_activities_target_hours" formControlName="other_activities_target_hours"
          class="form-control" min="0" step="0.01">
        <div *ngIf="other_activities_target_hours?.invalid" class="alert alert-danger">
          <div
            *ngIf="other_activities_target_hours?.errors?.['min'] || other_activities_target_hours?.errors?.['pattern']">
            Only positive numbers with up to 2 decimals allowed.
          </div>
        </div>
      </div>
    </div>

    <div class="k-form-field">
      <label class="form-label col-4 k-label" for="total_target_hours">Total Target Hours</label>
      <div class="col-3">
        <input type="number" id="total_target_hours" formControlName="total_target_hours" class="form-control" min="0"
          step="0.01">
        <div *ngIf="total_target_hours?.invalid" class="alert alert-danger">
          <div *ngIf="total_target_hours?.errors?.['min'] || total_target_hours?.errors?.['pattern']">
            Only positive numbers with up to 2 decimals allowed.
          </div>
        </div>
      </div>
    </div>

  </form>

  <kendo-dialog-actions>
    <button kendoButton (click)="onSaveAction()" class="btn btn-primary" [disabled]="editForm.invalid">Save</button>
    <button kendoButton (click)="onCancelAction()" class="btn btn-secondary">Cancel</button>
  </kendo-dialog-actions>
</div>
